// import { useInfiniteQuery } from "@tanstack/react-query";
import { SP_NAMES } from "api/constants";
import { spApiInstance } from "api/instance";
import { IReq } from "api/types";
import { useState } from "react";

interface options {
  body?: IReq;
  pageSize?: number;
}

export const useListLoader = <T>(spName: SP_NAMES, options?: options) => {
  const pageSize = options?.pageSize;

  const [items, setItems] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadData = async () => {
    try {
      setIsLoading(true);
      const result = await spApiInstance<T[]>(spName, options?.body);
      setItems(result);
    } catch (error) {
      // throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const loadPagedData = async ({
    pageParam = 0,
  }): Promise<{
    result: T[];
    next: number | undefined;
  }> => {
    try {
      pageParam === 0 && setIsLoading(true);
      const body = { ...options?.body, RowsOfPage: pageSize, Start: pageParam };

      const result = await spApiInstance<T[]>(spName, body);
      if (result.length < pageSize!) {
        return { result: result, next: undefined };
      }
      return { result: result, next: pageSize! + pageParam };
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  // const { data, hasNextPage, fetchNextPage, refetch } = useInfiniteQuery({
  //   enabled: false,
  //   queryKey: [spName],
  //   queryFn: loadPagedData,
  //   getNextPageParam: (a, f) => a.next,
  //   keepPreviousData: true,
  //   cacheTime: 0,
  // });

  const fetch = () => {
    if (pageSize ?? false) {
      // refetch();
      loadData();
    } else {
      loadData();
    }
  };

  const clear = () => {
    setItems([]);
  };

  // useEffect(() => {
  //   const flatList = data?.pages.reduce<T[]>((array, page) => {
  //     return array.concat(page.result);
  //   }, []);

  //   setItems(flatList || []);

  //   return () => {};
  // }, [data?.pages]);

  return {
    isLoading,
    result: items,
    // hasNextPage,
    fetch,
    clear,
    // fetchNextPage,
  };
};
